import getCssVariablesMap from './get-css-variables-map';

const copyCustomColorsBetweenCssRules = (sourceCssRule, targetCssRule, customColorsToCopy) => {
  const sourceCustomColors = getCssVariablesMap(sourceCssRule.style.cssText);

  customColorsToCopy.forEach((customColor) => {
    targetCssRule.style.setProperty(customColor, sourceCustomColors[customColor]);
  });
};

export default copyCustomColorsBetweenCssRules;
